import CaseStudySliderItemCard from "@/components/CaseStudiesSlider/CaseStudySliderItemCard";
import CaseStudiesCarousel from "@/components/CaseStudiesSlider/CaseStudiesCarousel";
import SectionContentWrapper from "@/components/Shared/SectionContentWrapper";
import styled, { css } from "styled-components";
import LogoMarquee from "@/components/LogoMarquee/LogoMarquee";
import LogoMarqueeWithTitle from "@/components/LogoMarqueeWithTitle/LogoMarqueeWithTitle";
import mq from "@/utils/mq";

const LogoWrapper = styled.div`
  margin-bottom: 32px;
  ${mq.mobile(css`
    margin-bottom: 42px;
  `)};
`;

export default function CaseStudiesSlider({ sectionTitle, caseStudies, logos }) {
  return (
    <SectionContentWrapper
      sectionTitle={sectionTitle?.[0] ? [{ ...sectionTitle[0], spacing: "expanded", noBottomPadding: true }] : []}
      theme={"dark"}
      darkMode>
      {logos && (
        <LogoWrapper>
          <LogoMarqueeWithTitle logos={logos} />
        </LogoWrapper>
      )}
      <CaseStudiesCarousel caseStudies={caseStudies} />
    </SectionContentWrapper>
  );
}
